/**
 * Schedule instants from DB / CricAPI are UTC; naive "YYYY-MM-DD HH:mm:ss" must not parse as browser-local.
 */
export function parseScheduleInstantAsUtc(raw: string | undefined | null): Date | null {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  if (/[zZ]$|[+-]\d{2}:\d{2}$|[+-]\d{4}$/.test(s)) {
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (s.includes('T')) {
    const d = new Date(s.endsWith('Z') ? s : `${s}Z`);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const m = s.match(/^(\d{4}-\d{2}-\d{2})[\sT](\d{1,2}:\d{2}(?::\d{2})?)$/);
  if (m) {
    const t = m[2].length === 5 ? `${m[2]}:00` : m[2];
    const d = new Date(`${m[1]}T${t}Z`);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatScheduleTimeUtc(d: Date): string {
  const h = d.getUTCHours();
  const mi = d.getUTCMinutes();
  const ampm = h >= 12 ? 'PM' : 'AM';
  const dh = h % 12 || 12;
  return `${dh}:${String(mi).padStart(2, '0')} ${ampm}`;
}

export function formatScheduleTimeBrowserLocal(d: Date): string {
  return d.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short'
  });
}

export function formatScheduleDateBrowserLocal(d: Date): string {
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
